import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

import styles from "./pages.module.css";
import PageLayout from "../components/PageLayout";


export default function Privacy() {
    const { i18n, t } = useTranslation();
    const [markdown, setMarkdown] = useState("");

    useEffect(() => {
        fetch(`/data/privacy/${i18n.language}.md`)
            .then((res) => {
                if (!res.ok) throw new Error(t("common.error"));
                return res.text();
            })
            .then((text) => setMarkdown(text))
    }, [i18n.language, t]);

    return (
        <PageLayout>
            <section className={styles.section}>
                <h2 className={styles.title}>{t("footer.privacy")}</h2>
                <ReactMarkdown>{markdown}</ReactMarkdown>
            </section>
        </PageLayout>
    );
}